import React from 'react'

interface InternalProcessFilledIconProps {
  color?: string
  width?: number
  height?: number
  alt?: string
}

const InternalProcessFilledIcon: React.FC<InternalProcessFilledIconProps> = ({
  color = '#010B34',
  width = 24,
  height = 24,
  alt = 'Internal process filled icon',
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      <path
        fill={color}
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.4492 2.36279C11.7831 2.14274 12.2169 2.14274 12.5508 2.36279L15.5508 4.33936C15.8313 4.52431 15.9999 4.83831 16 5.17432V6.99951H21C21.5521 6.99951 21.9998 7.44743 22 7.99951V20.9995C22 21.5518 21.5523 21.9995 21 21.9995H14V15.9995H10V21.9995H3C2.44772 21.9995 2 21.5518 2 20.9995V7.99951C2.00024 7.44743 2.44786 6.99951 3 6.99951H8V5.17432C8.00014 4.83831 8.16869 4.52431 8.44922 4.33936L11.4492 2.36279ZM4 18.9995H6V16.9995H4V18.9995ZM18 16.9995V18.9995H20V16.9995H18ZM4 14.9995H6V12.9995H4V14.9995ZM18 14.9995H20V12.9995H18V14.9995ZM4 10.9995H6V8.99951H4V10.9995ZM12 7.99951C11.1716 7.99951 10.5 8.67109 10.5 9.49951C10.5 10.3279 11.1716 10.9995 12 10.9995C12.8284 10.9995 13.5 10.3279 13.5 9.49951C13.5 8.67109 12.8284 7.99951 12 7.99951ZM18 10.9995H20V8.99951H18V10.9995Z'
      />
    </svg>
  )
}

export default InternalProcessFilledIcon
